import { createSelector } from 'reselect';
import { selectAllCategories } from './selectAllCategories';

const findOnlyHistCategory = (categories) =>
  categories.find(
    (category) => category.name === 'Хиты продаж' && category.block === 'Спецпредложение',
  );

export const selectOnlyHistCategory = createSelector(selectAllCategories, findOnlyHistCategory);
